import commonSlice from '@/redux/features/common.slice';
import { Icon, Tooltip } from '@shopify/polaris';
import { ClipboardIcon } from '@shopify/polaris-icons';
import { memo } from 'react';
import { useDispatch } from 'react-redux';
import { IconProps } from '@shopify/polaris/build/ts/src/components/Icon';
interface CopyIconProps extends Partial<IconProps> {
  copiedText: string;
}

const CopyIcon = ({ copiedText, tone = 'base' }: CopyIconProps) => {
  const dispatch = useDispatch();

  const handleCopy = () => {
    navigator.clipboard.writeText(copiedText);
    dispatch(commonSlice.actions.handleToast({ isOpen: true, content: 'Copied' }));
  };

  return (
    <div style={{ cursor: 'pointer' }} onClick={handleCopy}>
      <Tooltip content="Copy">
        <Icon source={ClipboardIcon} tone={tone} />
      </Tooltip>
    </div>
  );
};

export default memo(CopyIcon);
